var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.0227L18.6709 7.35955L18.9955 3.83727L15.5495 3.05455L13.7455 0L10.5 1.39364L7.25455 0L5.45045 3.045L2.00455 3.81818L2.32909 7.35L0 10.0227L2.32909 12.6859L2.00455 16.2177L5.45045 17.0005L7.25455 20.0455L10.5 18.6423L13.7455 20.0359L15.5495 16.9909L18.9955 16.2082L18.6709 12.6859L21 10.0227ZM7.99909 13.8505L5.72727 11.5595C5.63878 11.4712 5.56858 11.3663 5.52068 11.2509C5.47278 11.1354 5.44812 11.0116 5.44812 10.8866C5.44812 10.7616 5.47278 10.6378 5.52068 10.5223C5.56858 10.4068 5.63878 10.3019 5.72727 10.2136L5.79409 10.1468C6.16636 9.77455 6.77727 9.77455 7.14955 10.1468L8.68636 11.6932L13.6023 6.76773C13.9745 6.39545 14.5855 6.39545 14.9577 6.76773L15.0245 6.83455C15.3968 7.20682 15.3968 7.80818 15.0245 8.18045L9.37364 13.8505C8.98227 14.2227 8.38091 14.2227 7.99909 13.8505Z",
    fill: "#5BBF43"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.708a3ec12d0ca7e3d0c0e0e7a838b30e.svg";
export { ForwardRef as ReactComponent };